import {
  Box,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { formatNumber } from '../../../utils/Common'
import { Invoice } from '../../../models/Subscription'

interface PaymentHistoryProps {
  invoices: Invoice[]
}
export default function PaymentHistory(props: PaymentHistoryProps) {
  const unixToDate = (unixTimeStamp: any) => {
    // Convert to milliseconds (JavaScript timestamps are in milliseconds)
    const date = new Date(unixTimeStamp * 1000)
    // Get a readable date and time

    const readableDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }) // Format as UTC string
    return readableDate
  }
  const { invoices } = props

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        pointerEvents: 'auto',
        padding: '6px 6px 0 6px',
        borderRadius: '4px',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&-ms-overflow-style:': {
          display: 'none',
        },
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: '22px',
          lineHeight: '100%',
          letterSpacing: '0%',
          verticalAlign: 'middle',
        }}
      >
        History
      </Typography>
      <TableContainer sx={{ borderRadius: '2px 2px 0px 0px' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Due Date
                  {<SvgIcon />}
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Description
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Status
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Seats
                  {<SvgIcon />}
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Invoice Total
                  {<SvgIcon />}
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#878787',
                  }}
                >
                  Download
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {invoices?.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#797979',
                  }}
                >
                  {item.due_date || unixToDate(item.period_start)}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#797979',
                  }}
                >
                  {item.status}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#04002E',
                  }}
                >
                  <Box
                    sx={{
                      border: '1px solid #00C961',
                      background: '#E1FFE5',
                      textAlign: 'center',
                    }}
                  >
                    {item.status}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#797979',
                  }}
                >
                  {'-'}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#797979',
                  }}
                >
                  ${formatNumber(item.total / 100)}
                </TableCell>
                <TableCell
                  sx={{
                    borderLeft: '1px solidhsl(0, 0.00%, 89.40%)',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                    color: '#797979',
                  }}
                >
                  <Box
                    onClick={() => {
                      window.open(item.invoice_pdf)
                    }}
                    sx={{
                      cursor: 'pointer',
                    }}
                  >
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1 10.0042V19H19V10'
                        stroke='#797979'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                      <path
                        d='M14.5 9.5L10 14L5.5 9.5'
                        stroke='#797979'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                      <path
                        d='M9.99585 1V14'
                        stroke='#797979'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
